import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { persistor, store } from "./redux/store";
import { msalConfig } from './auth-config';
import AuthContextProvider from './contexts/AuthContext';
// import { Provider } from "react-redux";
// import { PersistGate } from "redux-persist/integration/react";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <Provider store={store}>
  // <PersistGate loading={null} persistor={persistor}>
  <React.StrictMode>
    <Router>
      <MsalProvider instance={msalInstance}>
        <AuthContextProvider>
        <App />
        </AuthContextProvider>
      </MsalProvider>
    </Router>
  </React.StrictMode>
  // </PersistGate>
  // </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
